
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: Storytelling
* Copyright IBM Corp. 2017, 2020
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'story': 'Histoire',
	'noDashboardFound': 'Impossible d\'extraire l\'histoire. Il n\'existe plus ou vous ne disposez pas des droits permettant de l\'afficher.',
	'noDashboardCapability': 'Vous ne disposez pas du droit permettant d\'utiliser des histoires',
	'noDashboardPermision': 'Vous ne disposez pas de privilèges suffisants pour afficher cette histoire',
	'defaultName': 'Nouvelle histoire',
	'storyProperties': 'Propriétés de l\'histoire',
	'createAvDataStoryLabel': 'Histoire',
	'createAvSlideShowLabel': 'Diaporama',
	'createAvPanAndZoomLabel': 'Visite guidée',
	'dashboard_save_success': 'Votre histoire a été sauvegardée.',
	'cmEmptySelection': 'L\'histoire a été supprimée. Tentez de procéder à la sauvegarde sous une nouvelle histoire.',
	'createStoryTitle': 'Créer une histoire',
	'transitionStyleTitle': 'Style de transition',
	'createButton': 'Créer',
	'cancelButton': 'Annuler',
	'dashboardResetTitle': 'Réinitialiser l\'histoire',
	'dashboardResetMessage': 'Voulez-vous vraiment réinitialiser toutes les modifications appliquées à cette histoire ?',
	'dashboardResetToast': 'Votre histoire a été réinitialisée.',
	'filter_drag_and_drop_all_tabs': 'Glissez-déposez des données ici pour filtrer toutes les scènes.',
	'filter_drag_and_drop_current_tab': 'Glissez-déposez des données ici pour filtrer cette scène.',
	'filterIconLabel_Global': 'Toutes les scènes',
	'filterIconLabel_Tab': 'Cette scène',
	'filterIconTooltip_Global': 'Toutes les scènes',
	'filterIconTooltip_Tab': 'Cette scène',
	'filterOverflowMenu_Global': 'Menu déroulant dynamique de toutes les scènes',
	'filterOverflowMenu_Tab': 'Menu déroulant dynamique de cette scène',
	'renameScene': 'Renommer la scène',
	'duplicateScene': 'Dupliquer la scène',
	'deleteScene': 'Supprimer la scène',
	'editTimelineHighlight': 'Editer une mise en évidence',
	'deleteTimelineHighlight': 'Supprimer la mise en évidence',
	'filter_includesAll': 'Tout inclure',
	'timeline_highlight_moved_to': 'Mise en évidence du calendrier linéaire %{id} déplacée à %{time}',
	'filter_tooltip': '[%{title}] - %{description}',
	'selectLabel': 'Sélectionner',
	'newDefaultStoryName': 'Histoire : %{modelName}',
	'exportLabel': 'Enregistrer',
	'exportAsLabel': 'Enregistrer sous :',
	'exportDialogTitle': 'Enregistrer en tant qu\'histoire',
	'exportDialogFooter': 'Boutons Enregistrer et Annuler',
	'loadAfterExportLabel': 'Ouvrir l\'histoire après l\'enregistrement',
	'selectTemplateLabel': 'Sélectionner un modèle',
	'outOfBoundsWarningMessage': 'Certains widgets de tableau de bord se trouvent en dehors de la grille et peuvent ne pas être affichés correctement après l\'exportation.',
	'emptyExploreCardsWarningMessage': 'Les cartes vides ont été supprimées lors de la sauvegarde sous une nouvelle histoire.',
	'dashboard_export_success': 'Votre tableau de bord a été enregistré comme histoire.',
	'explore_export_success': 'Votre exploration a été enregistrée comme une histoire.',
	'toastUpgradeDone': 'Votre histoire a été mise à niveau. Sauvegardez-le maintenant pour maintenir des performances optimales.',
	'navigationMarker': 'Repère de navigation',
	'navigateMarkers': 'Repères de navigation',
	'navNextMarker': 'Repère suivant',
	'navPrevMarker': 'Repère précédent',
	'navPrevMarkerAbbreviated': 'Repère préc.',
	'timelineSettingsButton': 'Options de lecture',
	'autoPlay': 'Lire toutes les scènes',
	'loop': 'Boucle',
	'refreshData': 'Rafraîchir au démarrage',
	'slideshowLabel': 'Diaporama',
	'panAndZoomLabel': 'Visite guidée',
	'slideShowLayoutLabel': 'Présentation en diaporama',
	'panAndZoomLayoutLabel': 'Présentation Visite guidée',
	'panAndZoomLayoutFooter': 'Une présentation Visite guidée est une série de scènes dans un canevas unique. Lorsque vous exécutez ce type d\'histoire, la présentation effectue des zooms et des panoramiques sur chaque scène séquentiellement. Cette présentation est différente d\'un diaporama, où chaque scène est présentée dans un nouveau canevas. La présentation Visite guidée comportant trois scènes connectées par des lignes vous permet de créer une séquence de scènes horizontales. Elle est utile si vous voulez afficher une chronologie.',
	'PanAndZoomLayout1': '5 scènes organisées dans un rectangle',
	'PanAndZoomLayout2': '4 scènes organisées sous forme d\'escalier de la gauche vers la droite',
	'PanAndZoomLayout3': '6 scènes organisées dans un rectangle',
	'PanAndZoomLayout4': '7 scènes organisées dans un rectangle, avec 6 petites scènes en haut et 1 grande scène en bas',
	'PanAndZoomLayout5': '3 scènes organisées avec 2 petites scènes en haut et 1 grande scène en bas',
	'PanAndZoomLayout6': 'Une séquence de 4 scènes organisées horizontalement',
	'pageSelectWarning': 'Sélectionnez une scène.',
	'noSceneTransitionLabel': 'Aucun',
	'sceneTransitionPropertyLabel': 'Transition de scène',
	'animatedPathSceneTransitionLabel': 'Chemin d\'accès animé',
	'sweepSceneTransitionLabel': 'Balayage',
	'storyTypeLabel': 'Type d\'histoire',
	'layoutLabel': 'Présentation',
	'tabName_animation': 'Animation',
	'propAniAnimation': 'Animation',
	'propAniTypeEntrance': 'Animation d\'entrée',
	'propAniDirectionIn': 'Direction d\'entrée',
	'propAniTypeExit': 'Animation de sortie',
	'propAniDirectionOut': 'Direction de sortie',
	'propAniDirection': 'Direction',
	'propAniEntrance': 'Entrée',
	'propAniTypeEntranceSlideIn': 'Glissement à l\'intérieur du cadre',
	'propAniTypeEntranceFadeIn': 'Fondu avant',
	'propAniTypeEntrancePivotIn': 'Pivotement dans le cadre',
	'propAniTypeEntranceScaleIn': 'Restauration de l\'échelle',
	'propAniTypeEntranceShrinkIn': 'Réduction dans le cadre',
	'propAniDirectionInLeft': 'De la gauche',
	'propAniDirectionInRight': 'De la droite',
	'propAniDirectionInTop': 'Du haut',
	'propAniDirectionInBottom': 'Du bas',
	'propAniExit': 'Quitter',
	'propAniTypeExitSlideIn': 'Glissement hors du cadre',
	'propAniTypeExitFadeIn': 'Fondu arrière',
	'propAniTypeExitPivotOut': 'Pivotement hors du cadre',
	'propAniTypeExitScaleIn': 'Avance dans le cadre',
	'propAniTypeExitExpandOut': 'Développement hors du cadre',
	'propAniDirectionOutLeft': 'Vers la gauche',
	'propAniDirectionOutRight': 'Vers la droite',
	'propAniDirectionOutTop': 'Vers le haut',
	'propAniDirectionOutBottom': 'Vers le bas',
	'propAniEntranceTime': 'Début à (secondes) :',
	'propAniExitTime': 'Fin à (secondes) :',
	'animationNoEntranceText': 'L\'animation d\'entrée ne se déclenche pas si le widget est au début de la scène.',
	'animationNoExitText': 'L\'animation de sortie ne se déclenche pas si le widget est à la fin de la scène.',
	'propAniTypeDataEntrance': 'Entrée des données',
	'propAniRevealDuration': 'Durée de l\'animation d\'entrée',
	'timelineAnimationProperties': 'Ouvrir les propriétés d\'animation',
	'scenesPropertiesSection': 'Scènes',
	'editStoryCoachMarkTitle': 'Editer l\'histoire',
	'editStoryCoachMarkContents': 'Cliquez sur l\'icône Crayon pour éditer cette histoire.',
	'addDataStoryCoachMarkContents': 'Faites glisser des données du panneau des données jusqu\'à votre histoire.',
	'expandSceneCoachmarkTitle': 'Ouvrir le calendrier linéaire',
	'expandSceneCoachmarkContents': 'Animez une scène en ajustant la visibilité de l\'objet en fonction de l\'heure et de la durée.',
	'overviewCoachmarkTitle': 'Scènes de présentation',
	'overviewCoachmarkContents': 'Utilisez les scènes de présentation au début et à la fin de votre histoire pour afficher une vue d\'ensemble de toutes les scènes. Depuis une scène de présentation, cliquez sur une scène et faites-la glisser pour la permuter avec une autre scène. Vous pouvez afficher et masquer les scènes de présentation dans les propriétés de l\'histoire.',
	'animatedPathCoachmarkTitle': 'Chemin d\'accès animé',
	'animatedPathCoachmarkContents': 'Pour animer un objet d\'une scène à l\'autre, dupliquez une scène contenant un objet. Ensuite, déplacez, redimensionnez ou faites pivoter l\'objet dupliqué dans la nouvelle scène.',
	'propShowStoryOverviewFirstSlide': 'Afficher toutes les scènes au début',
	'propShowStoryOverviewLastSlide': 'Afficher toutes les scènes à la fin',
	'storySceneSingleCountLabel': '1 scène',
	'storySceneCountLabel': '%{count} scènes',
	'storySceneRangeCountLabel': 'Scène %{index} sur %{count}',
	'storySceneExpand': 'Ouvrir le calendrier linéaire',
	'storySceneActionMenu': 'Menu d\'options de lancement de scène',
	'timelineRightContainerLabel': 'Groupe de contrôle du bouton Calendrier linéaire',
	'timelineViewLabel': 'Calendrier linéaire',
	'timelineZoomFit': 'Zoomer pour ajuster',
	'timelineZoomIn': 'Zoom avant',
	'timelineZoomOut': 'Zoom arrière',
	'timelinePositionIndicator': 'indicateur de position du calendrier linéaire à %{position}',
	'timelinePositionIndicatorMoveLeftTo': 'déplacement vers la gauche à %{position} de l\'indicateur de position du calendrier linéaire',
	'timelinePositionIndicatorMoveRightTo': 'déplacement vers la droite à %{position} de l\'indicateur de position du calendrier linéaire',
	'sceneStart': 'Passer au début de la scène à %{position}',
	'sceneEnd': 'Passer à la fin de la scène à %{position}',
	'timelineHighlightTitle': 'Mise en évidence',
	'addTimelineHighlight': 'Ajouter une mise en évidence',
	'addSceneBtnTitle': 'Ajouter une nouvelle scène avec le modèle par défaut',
	'addSceneChevronBtnTitle': 'Choisir un modèle de scène',
	'timelinePlay': 'Lire',
	'timelinePause': 'Pause',
	'sceneNavigation': 'Navigation dans la scène',
	'navNextScene': 'Scène suivante',
	'navPrevScene': 'Scène précédente',
	'navPrevSceneAbbreviated': 'Scène préc.',
	'navExitFullScreen': 'Quitter le mode plein écran',
	'navToggleOverview': 'Changer d\'aperçu',
	'rowNumber': 'Ligne %{number}',
	'overviewBtnLabel': 'Aperçu',
	'sceneListStart': 'Début de la présentation',
	'sceneListEnd': 'Fin de la présentation',
	'timelineLeftHandle': 'poignée gauche pour %{name}',
	'timelineRightHandle': 'poignée droite pour %{name}',
	'timelineLeftHandleNoTitle': 'poignée gauche',
	'timelineRightHandleNoTitle': 'poignée droite',
	'timelineMoveLeft': 'Déplacer %{object} vers la gauche',
	'timelineMoveRight': 'Déplacer %{object} vers la droite',
	'timelineMoveWidget': 'Widget de délai déplacé de %{newStartTime} à %{newEndTime}',
	'timelineMoveWidgetStartTime': 'Heure de début du widget de délai déplacée à %{newStartTime}',
	'timelineMoveWidgetEndTime': 'Heure de fin du widget de délai déplacée à %{newEndTime}',
	'timelineMoveWidgetDown': 'Widget de délai repoussé',
	'timelineMoveWidgetUp': 'Widget de délai avancé',
	'addSceneTitle': 'Ajouter une scène',
	'blankSceneLayout': 'Rapport vierge',
	'titleSceneLayout': 'Titre avec sous-titre',
	'sceneLayout1': 'Titre avec texte en regard d\'une visualisation',
	'sceneLayout2': 'Titre avec une visualisation',
	'sceneLayout3': 'Titre avec deux visualisations',
	'sceneLayout4': 'Multi-usage',
	'sceneLayout5': 'Pas de titre avec texte en regard d\'une visualisation',
	'sceneLayout6': 'Multi-usage 2 par 2',
	'sceneLayout7': 'Multi-usage 2 en regard de 1',
	'sceneLayout8': 'Multi-usage 1 en regard de 2',
	'sceneLayout9': 'Multi-usage 1 sur 2',
	'sceneLayout10': 'Multi-usage 2 sur 1',
	'sceneLayout11': 'Multi-usage 4 sur 1',
	'sceneLayout12': 'Multi-usage 1 sur 1 en regard de 2 par 2 sur 1',
	'titleWidgetPlaceholderText': 'Entrez votre titre ici',
	'subtitleWidgetPlaceholderText': 'Entrez votre sous-titre ici',
	'createStoryViewTitle': 'Créer une histoire',
	'defaultStoryName': 'Nouvelle histoire',
	'screenshot_label': 'Histoire %{title}',
	'screenshot_label_scene': 'Scène %{sceneTitle} de l\'histoire %{title}',
	'filmstripHandleOpenLabel': 'Ouvrir le sélecteur de scène',
	'filmstripHandleCloseLabel': 'Fermer le sélecteur de scène'
});
